import { queryOptions } from "@tanstack/react-query";

import { api } from "@/api/api";
import type { Trip, TripDetails } from "@/features/trips/types/types";
import type {
  FindPackageByIdOutputDto,
  FindPackagesOutputDto,
} from "@/types/codegen";

export const tripQueryOptions = (tripId: string) =>
  queryOptions({
    queryKey: ["packages", tripId],
    queryFn: ({ signal }) =>
      api.get<FindPackageByIdOutputDto>(`/packages/packages/${tripId}`, {
        signal,
      }),
    // TODO: Remove hardcoded values once BE supports these fields
    select: (response): TripDetails => {
      return {
        ...response.data.data,
        hasOptionalTours: true,
        tourPrice: 11000,
      };
    },
    throwOnError: false,
  });

type TripsQueryOptionsParams = {
  sortField?: "createdAt" | "name" | "price" | "position" | "durationInDays";
  sortOrder?: "ASC" | "DESC";
};

export const tripsQueryOptions = (params?: TripsQueryOptionsParams) => {
  const normalizedParams: TripsQueryOptionsParams = {
    sortField: "position",
    sortOrder: "ASC",
    ...params,
  };

  return queryOptions({
    queryKey: ["packages", normalizedParams],
    queryFn: ({ signal }) =>
      api.get<FindPackagesOutputDto>("/packages/packages", {
        signal,
        params: normalizedParams,
      }),
    select: (response): Trip[] => response.data.data.packages,
    throwOnError: false,
  });
};
